import { FormActions } from '../../Form'
import { EmailCreationFormMassMailingCheckbox } from '../EmailCreationFormMassMailingCheckbox'

import { EmailCreationFormHelpersActions } from './EmailCreationFormHelpersActions'

function EmailCreationFormActions({
  availableMore,
  availablePreview,
  availableTestVariables,
  children,
  emptyAccountField,
  emptyRecipients,
  hideMassMailing,
  isMobileActions,
  isSubmitting,
  isTesting,
  mass,
  onChangeMass,
  onPreview,
  onTestVariables,
  ...actionProps
}) {
  return (
    <FormActions {...actionProps} isSubmitting={isSubmitting}>
      {!isMobileActions && !hideMassMailing ? (
        <EmailCreationFormMassMailingCheckbox
          checked={mass}
          onChange={onChangeMass}
        />
      ) : null}
      {availableMore && !isMobileActions ? (
        <EmailCreationFormHelpersActions
          disabled={isSubmitting}
          disablePreview={!availablePreview}
          disableVariables={!availableTestVariables}
          emptyAccountField={emptyAccountField}
          emptyRecipients={emptyRecipients}
          isTesting={isTesting}
          mass={mass}
          onPreview={onPreview}
          onTestVariables={onTestVariables}
        />
      ) : null}
      {children}
    </FormActions>
  )
}

export default EmailCreationFormActions
